var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstructionDashbord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione-monotone",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.063 17h-8.438v-2.148a6.564 6.564 0 1 0-3.75 0V17h-33.75v-2.148A6.564 6.564 0 0 0 13.25 2a6.562 6.562 0 0 0-1.874 12.852V17H2.938a.937.937 0 0 0-.938.938v18.75c0 .519.419.938.938.938h8.438v6.563H7.938v3.75h3.437v10.752C11.375 59.53 9.5 62 9.5 62H17s-1.875-2.47-1.875-3.311V47.938h33.75V58.69C48.875 59.53 47 62 47 62h7.5s-1.875-2.47-1.875-3.311V47.938h3.437v-3.75h-3.437v-6.563h8.438a.937.937 0 0 0 .938-.938v-18.75a.938.938 0 0 0-.938-.937m-20.704 1.875h9.907L43.292 35.75h-9.905l6.972-16.875M8.563 8.563c0-2.587 2.099-4.688 4.688-4.688s4.688 2.101 4.688 4.688a4.688 4.688 0 0 1-9.376 0M4.145 35.468a.93.93 0 0 1-.27-.655v-15c0-.519.419-.938.938-.938h6.579L4.145 35.468m9.105 11.283a.688.688 0 1 1 0-1.376a.688.688 0 0 1 0 1.376m.053-11.001l7.372-16.875h9.94L23.641 35.75H13.303m35.572 8.438h-33.75v-6.563h33.75v6.563m1.875 2.563a.688.688 0 1 1 0-1.376a.688.688 0 0 1 0 1.376m0-33.501a4.688 4.688 0 1 1 0-9.376a4.688 4.688 0 0 1 0 9.376m9.375 21.563a.937.937 0 0 1-.938.938h-6.149l6.842-16.557a.927.927 0 0 1 .245.619v15",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionDashbord);
export default __webpack_public_path__ + "static/media/construction-dashbord.1a3050bded35f35ca19ed2a0b03857e3.svg";
export { ForwardRef as ReactComponent };